// extracted by mini-css-extract-plugin
module.exports = {"deleteModal":"src-containers-Modifications-Modals-styles___deleteModal"};